import React, { useEffect, useState } from 'react';
import GalaIcon from 'src/GalaIcon';

interface IPrizePool {
    matches: number;
    prizePool: number;
}

const CurrentPools: React.FC<{
  currentPotSize: number
}> = ({ currentPotSize }) => {
    const [currWinnings, setCurrWinnings] = useState<IPrizePool[]>([]);
    const NUM_WINNING_NUMBERS = 8;

    const rewardPortionForNumMatches: Record<number, number> = {
        8: 0.4,
        7: 0.22,
        6: 0.15,
        5: 0.1,
        4: 0.08,
        3: 0.05,
        2: 0,
        1: 0,
        0: 0,
      };
      
      useEffect(()=>{
        const potSizeForNumMatches = Array(NUM_WINNING_NUMBERS + 1)
        .fill(0)
        .map((_,numWinningNumbers) => {
          const rewardPortion = rewardPortionForNumMatches[numWinningNumbers];
          return currentPotSize * rewardPortion;
        });

        const currentResults = [];
        for(let i = 0; i < NUM_WINNING_NUMBERS + 1; i++){
            const obj = {
                matches: i,
                prizePool: potSizeForNumMatches[i]
            }
            currentResults.push(obj);
        }
    
        setCurrWinnings(currentResults.reverse());
      },[currentPotSize])
    
  return (
    <section className="past-draws w-full py-6 relative">
        <h2 className='text-2xl font-bold text-white text-left mb-4'>
            See What You Can Win
        </h2>
        <span aria-label='Live Updates' aria-hidden="true" className="animate-bounce-centered font-normal z-10 absolute top-18 left-1/2 sm:left-[68%] transform -translate-x-1/2 origin-center p-2 px-3 whitespace-nowrap leading-none text-xs bg-purple-800 text-white rounded-full">Live Updates</span>

            <div className="pt-4 w-full pb-6 mb-4 overflow-x-auto">
                {currentPotSize > 0 ? (
                    <table className="animation-fade mt-2 w-full min-w-96 text-sm text-left text-lottoblue-400 border-spacing-4 border-0">
                        <thead className='border-0'>
                        <tr>
                            <th className="font-bold text-center text-sm p-2 text-lottoblue-600 bg-lottoblue-700 border-r-8 border-[#020025]">Matches</th>
                            <th className="font-bold text-center text-sm p-2 text-lottoblue-600 bg-lottoblue-700 border-r-8 border-[#020025] relative flex items-center justify-center">
                                Shared Rewards
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {[...currWinnings].filter(x => x.matches > 2).map((tier, index) => (
                            <tr key={index} className={`${index < [...currWinnings].filter(x => x.matches > 2).length - 1 ? 'border-b border-lottoblue-700': ''}`}>
                            <td className="py-4 text-center">Match {tier.matches}</td>
                            <td className="py-4 text-center"><div className='flex flex-row flex-nowrap items-center justify-center gap-2'><GalaIcon className="w-4 h-4" /> {Math.round(tier.prizePool).toLocaleString()}</div></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                ) : (
                <span className="text-gray-500 italic">No data available</span>
                )}
            </div>
            <div className="w-full p-4 rounded-lg bg-gray-900 mb-8">
                <p className='text-center text-sm text-lottoblue-400'>Match at least 1 number for a <span className="text-lottogreen font-bold">free ticket</span> in the next drawing!</p>
            </div>
    </section>
  );
};

export default CurrentPools;
